import { Link } from "react-router-dom";
import MarketingLayout from "@/components/layout/MarketingLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Clock, Wallet, ShieldCheck } from "lucide-react";

export default function SalaryAdvance() {
  return (
    <MarketingLayout>
      <section className="page-shell px-6 py-20 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 space-y-6">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Product · Salary Advance</div>
          <h1 className="font-display text-5xl lg:text-6xl leading-[1.05]">Bridge the gap till payday, gracefully.</h1>
          <p className="text-lg text-muted-foreground max-w-xl">Salary Advance is a short-term loan linked to your monthly salary — up to ₹1L, tenure 1–3 months, repayable in one or a few instalments.</p>
          <div className="flex gap-3 flex-wrap">
            <Link to="/register"><Button size="lg" className="rounded-full brand-gradient text-white" data-testid="sa-apply">Apply Now</Button></Link>
            <Link to="/emi-calculator"><Button size="lg" variant="outline" className="rounded-full">Try Calculator</Button></Link>
          </div>
        </div>
        <div className="lg:col-span-5">
          <Card className="p-6 rounded-3xl glass">
            <div className="text-xs uppercase tracking-widest text-muted-foreground">Illustrative sanction</div>
            <div className="grid grid-cols-3 gap-3 mt-4">
              <div className="rounded-xl bg-muted p-4"><div className="text-xs">Amount</div><div className="font-display text-2xl">₹50K</div></div>
              <div className="rounded-xl bg-muted p-4"><div className="text-xs">Tenure</div><div className="font-display text-2xl">2 mo</div></div>
              <div className="rounded-xl bg-muted p-4"><div className="text-xs">Rate</div><div className="font-display text-2xl">18%</div></div>
            </div>
            <div className="mt-5 space-y-2 text-sm">
              <div className="flex justify-between"><span className="text-muted-foreground">Total interest</span><span>₹1,510</span></div>
              <div className="flex justify-between"><span className="text-muted-foreground">Processing fee (1%)</span><span>₹500</span></div>
              <div className="flex justify-between font-medium border-t pt-2"><span>You repay</span><span>₹52,010</span></div>
            </div>
          </Card>
        </div>
      </section>

      <section className="page-shell px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
          {[
            { icon: Wallet, t: "Up to ₹1,00,000" },
            { icon: Clock, t: "1–3 month tenure" },
            { icon: ShieldCheck, t: "Encrypted end-to-end" },
            { icon: CheckCircle2, t: "Prepay without penalty" },
          ].map(({ icon: Icon, t }) => (
            <Card key={t} className="p-5 card-hover flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg brand-gradient text-white flex items-center justify-center"><Icon className="h-5 w-5" /></div>
              <div className="text-sm font-medium">{t}</div>
            </Card>
          ))}
        </div>
      </section>

      <section className="page-shell px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Card className="rounded-3xl p-8">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Eligibility</div>
          <h3 className="font-display text-2xl mt-2">Who can apply?</h3>
          <ul className="mt-4 space-y-2 text-sm">
            {["Salaried, aged 21–60", "Monthly net income ≥ ₹20,000", "Salary credited to bank for ≥ 3 months", "Aadhaar + PAN, valid mobile number"].map((t) => (
              <li key={t} className="flex items-start gap-2"><CheckCircle2 className="h-4 w-4 text-primary mt-0.5" /><span>{t}</span></li>
            ))}
          </ul>
        </Card>
        <Card className="rounded-3xl p-8">
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Fees & Charges</div>
          <h3 className="font-display text-2xl mt-2">Fully disclosed upfront</h3>
          <ul className="mt-4 space-y-2 text-sm">
            <li>Interest: 18–24% p.a. (product-specific)</li>
            <li>Processing fee: 1–2% + GST</li>
            <li>Late payment: ₹200 + 3% p.m. on overdue</li>
            <li>Prepayment: Nil</li>
          </ul>
        </Card>
      </section>
    </MarketingLayout>
  );
}
